import { portalApi } from "@services/api/portalApi";

export type TimetableFetchOptions = {
    censusDate?: string;
}

export async function getStudentTimetable(studentNo: number, options?: TimetableFetchOptions): Promise<TimetabledLesson[]> {
    try {
        const response = await portalApi.get<TimetableApiLesson[]>(`/timetables/student/${studentNo}`, {
            params: {
                censusDate: options?.censusDate,
            },
        })
        return response.data.map(normalizeTimetabledLesson)
    } catch (error) {
        console.error("Error fetching student timetable:", error);
        throw error
    }
}

export type TimetabledLesson = {
    dayOfWeek: number;
    dayName: string;
    period: number;
    timeStart: string;
    classCode: string;
    classId: string;
    courseCode: string;
    subjectCode: string;
    subjectName: string;
    teacherInitials: string;
    staffId: string;
    roomNumber: string;
    attendancePercent?: number
}

type TimetableApiLesson = {
    dayOfWeek: number;
    dayName: string;
    period: number;
    timeStart: string;
    classCode: string;
    classId: number;
    courseCode: string;
    subjectCode: string;
    subjectName: string;
    teacherInitials?: string;
    staffInitials?: string;
    staffId?: number;
    roomNumber: string | null;
    attendancePercent?: number | null;
}

function normalizeTimetabledLesson(lesson: TimetableApiLesson): TimetabledLesson {
    return {
        dayOfWeek: lesson.dayOfWeek,
        dayName: lesson.dayName,
        period: lesson.period,
        timeStart: lesson.timeStart,
        classCode: lesson.classCode,
        classId: String(lesson.classId),
        courseCode: lesson.courseCode,
        subjectCode: lesson.subjectCode,
        subjectName: lesson.subjectName,
        teacherInitials: lesson.teacherInitials ?? lesson.staffInitials ?? "",
        staffId: lesson.staffId == null ? "" : String(lesson.staffId),
        roomNumber: lesson.roomNumber ?? "",
        attendancePercent: lesson.attendancePercent ?? undefined,
    };
}

export async function getStaffTimetable(staffInitials: string, options?: TimetableFetchOptions): Promise<TimetabledLesson[]> {
    try {
        const response = await portalApi.get<TimetableApiLesson[]>(`/timetables/staff/${encodeURIComponent(staffInitials)}`, {
            params: {
                censusDate: options?.censusDate,
            },
        })
        return response.data.map(normalizeTimetabledLesson)
    } catch (error) {
        console.error("Error fetching staff timetable:", error);
        throw error
    }
}

export async function getRoomTimetable(roomCode: string, options?: TimetableFetchOptions): Promise<TimetabledLesson[]> {
    try {
        const response = await portalApi.get<TimetableApiLesson[]>(`/timetables/room/${encodeURIComponent(roomCode)}`, {
            params: {
                censusDate: options?.censusDate,
            },
        })
        return response.data.map(normalizeTimetabledLesson)
    } catch (error) {
        console.error("Error fetching room timetable:", error);
        throw error
    }
}
